export var CurrenciesIsoCodes;
(function (CurrenciesIsoCodes) {
    CurrenciesIsoCodes["BRL"] = "BRL";
    CurrenciesIsoCodes["USD"] = "USD";
})(CurrenciesIsoCodes || (CurrenciesIsoCodes = {}));
export var Currencies = {
    BRL: {
        isoCode: "BRL",
        name: "Real brasileiro",
        symbol: "R$"
    },
    USD: {
        isoCode: "USD",
        name: "American Dollar",
        symbol: "US$"
    }
};
